export default __webpack_public_path__ + "media/7659988030298fab523211cf7b850b8fe8416a60a624fc6c768552f0f3a64081.svg";